import { DependencyList, useCallback, useEffect, useRef } from 'react';

export interface UseDebounceReturn {
  isReady: () => boolean | null;
  cancel: () => void;
}

export function useDebounce(
  fn: () => void,
  ms: number = 0,
  deps: DependencyList = [],
): UseDebounceReturn {
  const ready = useRef<boolean | null>(false);
  const timeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const callback = useRef(fn);
  callback.current = fn;

  const isReady = useCallback(() => ready.current, []);

  const cancel = useCallback(() => {
    ready.current = null;
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }, []);

  const reset = useCallback(() => {
    ready.current = false;
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      ready.current = true;
      callback.current();
    }, ms);
  }, [ms]);

  useEffect(() => {
    reset();
    return cancel;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, reset]);

  return { isReady, cancel };
}
